import axios from '@customAxios';
var API_BASE_URL = '/api/do_not_sell_my_personal_info';
var OptOut = axios.create({
    baseURL: API_BASE_URL,
});
// TODO (geraldine): Use JSON approach for this
export var postOptOut = function (requestBody) {
    return OptOut.post('', requestBody);
};
